import {ApolloError} from "@apollo/client";
import log from "loglevel";
import {AgGridReact} from "@ag-grid-community/react";
import {RefObject, useEffect, useRef} from "react";
import {Constants} from "../constants/constants";

export const useGridRefreshOnInterval = (
  soure: string,
  gridRef: RefObject<AgGridReact>,
  gridReady: boolean,
  datasourceFailed: ApolloError | undefined,
  intervalMs?: number,
  paused?: boolean,
  // Refresh even with selected rows; rows keep their selection across refreshes when the grid has getRowId
  refreshWithSelectedRows = false
) => {
  const wasPausedRef = useRef(paused);

  // Trigger immediate refresh when resuming from paused state
  useEffect(() => {
    if (
      wasPausedRef.current &&
      !paused &&
      gridReady &&
      gridRef.current?.api.getSelectedRows().length === 0 &&
      !datasourceFailed
    ) {
      log.debug(`${soure} Grid - Resuming from pause, immediate refresh`);
      gridRef.current?.api.refreshServerSide();
    }
    wasPausedRef.current = paused;
  }, [paused, gridReady, gridRef, datasourceFailed, soure]);

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      if (gridReady && (refreshWithSelectedRows || gridRef.current?.api.getSelectedRows().length === 0)) {
        if (!datasourceFailed) {
          log.debug(`${soure} Grid - Refresh on interval`);
          gridRef.current?.api.refreshServerSide();
        }
      } else {
        log.log(`${soure} Grid - Selected rows. Not refreshing on interval`);
      }
    }, intervalMs ?? Constants.GENERAL_POLLING_INTERVAL);
    return () => {
      log.debug(`clear interval ${soure}`);
      clearInterval(interval);
    };
  }, [datasourceFailed, gridReady, gridRef, intervalMs, paused, soure, refreshWithSelectedRows]);
};
